import styled, { css } from "styled-components";
import { RowFlex } from "@/main/components/shared/styles";
import { KOGMediaQuery } from "@/main/services/utilsLayout";
import { LabelArea, ContentArea } from "@/main/components/common/columnLabel/styles";

export const AreaIssues = styled(RowFlex)`
	width: auto;
	flex-direction: column;
	flex: 1;

	@media (max-width: 740px) {
		flex-direction: column;
		gap: 15px;
	}

	> div {
		margin-right: 50px;
	}
`;

export const LabelTitle = styled.div`
	font-weight: bold;
	font-size: 1rem;
`;
export const LabelText = styled.div`
	font-weight: bold;
	color: ${({ theme }) => theme.red};
`;
export const AreaButtons = styled.div`
	gap: 10px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-items: stretch;
	button {
		width: 100%;
		max-width: 100%;
		min-width: 200px;
	}

	@media (max-width: 768px) {
		width: 100%;

		button {
			min-width: 100%;
		}
	}
`;
export const ButtonHistory = styled.div`
	@media (max-width: 768px) {
		width: 100%;
		button {
			padding: 5px;
			max-width: unset;
			min-width: 77px;
		}
	}
`;

export const ContentAccordionQuoteHistory = styled.div`
	> .MuiAccordionDetails-root {
		max-height: calc(85vh - 57px - 40px - 27px - 33px - 19px);
	}
`;

export const FooterButtonsHistory = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 1rem 0 0;
`;

export const AreaInfoOrder = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr 2fr;
	gap: 2rem;
	width: 100%;

	${LabelArea},
	${ContentArea} {
		display: grid;
	}

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.desktop,
			includeOrientation: false,
			styles: css`
				grid-template-columns: 1fr;
			`,
		})} {
	}
`;
